export const PRIVACY_POLICY =
	"https://felixmobile.com.au/terms-policies/privacy";

export const TAndC = "https://felixmobile.com.au/terms-policies/general-terms";

export const CIS =
	"https://felixmobile.com.au/terms-policies/critical-information-summaries";

export const SHORT_FORM_TANDC =
	"https://felixmobile.com.au/terms-policies/short-form-terms-and-conditions";

export const STANDARD_FORM_TANDC =
	"https://felixmobile.com.au/terms-policies/standard-form-of-agreement";
